import { css } from "@vitality-ds/system";
export default css({
  marginTop: "-$md",
  marginRight: "-$md"
});